import {Component, OnInit, Optional} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FUISpinnersService, FUIStackedPageContextService, FUIStackedPageService} from "@fedelta-pos/ui";
import {ErrorHandlerService} from "../../../error-handler.service";
import {CustomerInstanceService} from "../customer-instance.service";
import {CustomerInstanceData} from "../customer-instance.data";
import {CustomerInstanceEditPageComponent} from "../customer-instance-edit/customer-instance-edit-page.component";

@Component({
    selector: "fhm-customer-instance-search-page",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./customer-instance-search-page.component.html",
    providers: [CustomerInstanceService],
    standalone: false
})
export class CustomerInstanceSearchPageComponent implements OnInit {

    CustomerInstanceData = CustomerInstanceData;

    gridData: CustomerInstanceData[] = [];

    type: string;
    searchMode: boolean;

    constructor(
                private router: Router,
                private errorHandler: ErrorHandlerService,
                private route: ActivatedRoute,
                private spinnersService: FUISpinnersService,
                private customerInstanceService: CustomerInstanceService,
                private stackedPageService: FUIStackedPageService,
                @Optional() private stackedPageContextService: FUIStackedPageContextService) {
    }

    ngOnInit(): void {
        if (this.stackedPageContextService) {
            this.searchMode = this.stackedPageContextService.params.searchMode;
            this.stackedPageContextService.title = "Customers";
            this.type = "all";
        }

        this.route.paramMap.subscribe(params => {
            const type: string = params.get("type");
            if (type === "fedelta" || type === "chewzie") {
                this.type = type;
            } else if (this.type !== "all") {
                this.type = "chewzie";
            }

            this.load();
        });
    }

    async load(): Promise<void> {
        this.spinnersService.open();
        try {
            this.gridData = await this.customerInstanceService.getCustomerInstances(this.type);
        } catch (error) {
            this.errorHandler.handleErrorResponse(error);
        } finally {
            this.spinnersService.close();
        }
    }

    recordSelected(record: any): void {
        if (this.searchMode) {
            this.stackedPageContextService.confirm(record["id"]);
        } else {
            this.router.navigate(["/main/customer-instance-edit/" + record["id"]]);
        }
    }

    createNew(): void {
        if (this.searchMode) {
            this.stackedPageService.open(CustomerInstanceEditPageComponent, {}).toPromise().then(async (id) => {
                if (id) {
                    this.stackedPageContextService.confirm(id);
                }
            });
        } else {
            this.router.navigate(["/main/customer-instance-edit/new"]);
        }
    }
}
